module.exports = __webpack_public_path__ + "img/ИФ-1(А)-027.0e4cf158.png";